import { Box, Tabs, Tab, SvgIcon } from '@mui/material';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import { HeadTag } from 'shared/components';
import AccountDetailPage from './accounts/Main';
import SecurityDetailPage from './security/Main';
import ManagementDetailPage from './management/Main';
import { ReactComponent as Account } from 'assets/images/ic_account.svg';
import { ReactComponent as ShieldSecurity } from 'assets/images/ic_shield_security.svg';
import { ReactComponent as Settings } from 'assets/images/icon_settings.svg';
import PageHeader from 'shared/components/PageHeader';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
// import UserDetailsForm from '../profile/components/UserDetailsForm';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const UserDetailPage = (): ReactElement => {
  const [value, setTabValue] = useState<number>(0);
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const { tabIndex } = queryParams;
  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    },
    []
  );
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Hooks
  useEffect(() => {
    if (tabIndex) {
      setTabValue(parseInt(`${tabIndex}`, 10));
    }
  }, [tabIndex]);

  // UI Elements
  return (
    <>
      <PageHeader
        title="Settings"
        description="Manage your account settings and preferences."
      />
      <HeadTag title="Settings" />
      <Box className="settings-wrapper">
        <Box className="settings-container">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Account"
                iconPosition="start"
                icon={
                  <SvgIcon
                    component={Account}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#76A81F"
                  />
                }
                {...a11yProps(0)}
              />
              <Tab
                label="Security"
                iconPosition="start"
                icon={
                  <SvgIcon
                    component={ShieldSecurity}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#76A81F"
                  />
                }
                {...a11yProps(1)}
              />
              <Tab
                label="Management"
                iconPosition="start"
                icon={
                  <SvgIcon
                    component={Settings}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                    htmlColor="#76A81F"
                  />
                }
                {...a11yProps(2)}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <AccountDetailPage />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <SecurityDetailPage />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <ManagementDetailPage />
          </CustomTabPanel>
        </Box>
      </Box>
    </>
  );
};

export default UserDetailPage;
